export enum InstallFlowDeviceOrder {

    dismantledImages,
    serialAndPartNumbers,
    generalDismantledProperties
}